import { AllActionsSection, PermissionEnum } from './types';
import permissionsTree from './variables';
import getPreparePermissions from '../user-list/helpers/get-permissions';

const getSectionActions = () => {
  const res: AllActionsSection = {};

  const columnsData = getPreparePermissions(permissionsTree);

  Object.entries(columnsData).map(
    ([key, value]) =>
      value?.pages &&
      Object.values(value.pages)
        .filter((item) => item?.actions)
        .forEach((item) => {
          res[key as PermissionEnum] = {
            ...res[key as PermissionEnum],
            ...item?.actions,
          };
        }),
  );

  return res;
};

const sectionActions: AllActionsSection = getSectionActions();

export default sectionActions;
